import { useCoordinatorMenu } from "@/queries/menu.queries";

const defectMenus: Record<string, string> = {
  BWI: "DefectTypeBWI",
  VT: "DefectTypeVT",
  PT: "DefectTypePT",
  UT: "DefectTypeUT",
  ET: "DefectTypeET",
  PMIVT: "DefectTypePMIVT",
  PMIPT: "DefectTypePMIPT",
  PMIUT: "DefectTypePMIUT",
  PMIET: "DefectTypePMIET",
};

export function useDefectTypeMenu(discipline: string) {
  return useCoordinatorMenu(defectMenus[discipline]);
}
